<app-default-layout (collapseState)="updateSidebarCollapsed($event)" (mobileExpandedState)="updateMobileNavExpanded($event)" [frontendVersion]="frontendVersion" [backendVersion]="backendVersion">
  <app-default-menu slot="sidebar" [collapsed]="_sidebarCollapsed"></app-default-menu>
  <app-default-menu slot="mobile" [mobileExpanded]="_mobileNavExpanded"></app-default-menu>
</app-default-layout>
